import { useLiveQuery } from 'dexie-react-hooks'
import { FC } from 'react'

import db from 'mobile_web/modules/db'
import { ImageSizePreset } from '../../../common_lib/types'
import { generateImageSrcSet, generateImageUrl } from '../../../common_lib/utils'

interface BadgeGroupCardProps {
	id: number
	toggleBadgeGroupModal: () => void
}

const BadgeGroupCard: FC<BadgeGroupCardProps> = ({ id, toggleBadgeGroupModal }) => {
	const badgeGroup = useLiveQuery(() => db.badgeGroups.get({ id }), [id])
	const badges = useLiveQuery(() => db.badges.where({ group_id: id }).toArray()) || []
	const recentlyEarnedBadges = useLiveQuery(() => db.recentlyEarnedBadges.toArray())
	const allEarnedBadges = recentlyEarnedBadges ? recentlyEarnedBadges.map((badge) => badge.badge_id) : []
	const earnedBadges = badges.filter(badge => allEarnedBadges.includes(badge.id));

	const focalPoint = badgeGroup?.badge_group_media_item?.file?.focal_point
	const crop = focalPoint && (focalPoint[0] !== 0.5 || focalPoint[1] !== 0.5)
	const imageSrc =
	badgeGroup?.badge_group_media_item?.file
			? generateImageUrl(badgeGroup.badge_group_media_item.file, {
				imageSizePreset: ImageSizePreset.Grid,
				crop,
				focalPoint,
			})
			: ''
	const imageSrcSet =
	badgeGroup?.badge_group_media_item?.file
			? generateImageSrcSet(badgeGroup.badge_group_media_item.file, {
				imageSizePreset: ImageSizePreset.Grid,
				crop,
				focalPoint,
			})
			: ''

	const handleClickBadge = () => {
		toggleBadgeGroupModal()
	}

	return (
		<button className="badge-group-card" onClick={handleClickBadge}>
			<div className="badge-group-card-image">
				<div className="progress-spacer">
					<img src={imageSrc} srcSet={imageSrcSet} alt="" />
				</div>
				<svg
					width="100" height="100" viewBox="0 0 100 100"
					className="circular-progress" style={{ "--progress": earnedBadges.length / badges.length * 100 } as React.CSSProperties}
				>
					<circle className="progress bg" />
					<circle className="progress fg" />
				</svg>
			</div>
			<h4>{badgeGroup?.title}</h4>
		</button>
	)
}

export default BadgeGroupCard
